export const INFO_WIDTH = 200
export const INFO_TOP_MARGIN= 22
